import { render, staticRenderFns } from "./TournamentBlockEditable.vue?vue&type=template&id=7233652e&"
import script from "./TournamentBlockEditable.vue?vue&type=script&lang=js&"
export * from "./TournamentBlockEditable.vue?vue&type=script&lang=js&"
import style0 from "./TournamentBlockEditable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports